import React, { useEffect, useState } from "react";
import { Box, Grid, Rating, TextField, Typography, useMediaQuery } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";

import { useTranslation } from "react-i18next";
import MainCard from "../components/MainCard";
import { DEFAULT_THEME, getTheme } from "../utils/theme";
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp";

const Completed = (props) => {
  const { style } = props;

  const isTablet = useMediaQuery(getTheme().breakpoints.down("tablet"));
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  // const [questions, setQuestions] = useState([]);

  const styles = {
    card: {
      ...style,
    },
    root: {
      padding: isTablet ? "1rem 2vw" : "1rem 10vw",
    },
    text: {
      fontSize: isTablet ? "18px" : "32px",
      fontFamily: DEFAULT_THEME.typography.fontFamilyBold,
    },
    button: {
      backgroundColor: "#646b52",
      marginTop: "2rem",
      width: "300px",
      "&:hover": {
        backgroundColor: "#646b52",
      },
    },
  };

  return (
    <Grid container sx={{ ...styles.card }}>
      <MainCard>
        <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ ...styles.root }}>
          <CheckCircleOutlineSharpIcon fontSize="large" color="success" align="center" />
          <Box m={2} />
          <Typography sx={{ ...styles.text }} align="center">
            ANKETE KATILIMINIZ İÇİN TEŞEKKÜRLER
          </Typography>
        </Grid>
      </MainCard>
    </Grid>
  );
};

export default Completed;
